import { LocaleEnum } from '../schema/locale';
import { StoreCode, storeCodeSchema, STORES_QA } from '../schema/storeCode';

const { us, au, nz, eu, uk, dev, qa, aud, nzd, eud, ukd, jp } = storeCodeSchema.enum;

export const SHOPIFY_API_VERSION = '2023-04';

export const SHOPIFY_STORE_DOMAIN: Record<StoreCode, string> = {
  [us]: 'athleticgreensusa.myshopify.com',
  [au]: 'athleticgreensusa.myshopify.com',
  [nz]: 'athleticgreensusa.myshopify.com',
  [eu]: 'athleticgreenseu.myshopify.com',
  [uk]: 'athleticgreensuk.myshopify.com',
  [jp]: 'athleticgreensjp.myshopify.com',
  [qa]: 'athleticgreens-qa.myshopify.com',
  [dev]: 'development-ag1.myshopify.com',
  [aud]: 'athleticgreens-qa.myshopify.com',
  [nzd]: 'athleticgreens-qa.myshopify.com',
  [eud]: 'ag-development-eu.myshopify.com',
  [ukd]: 'ag-development-uk.myshopify.com'
} as const;

export const SHOPIFY_STORE_CODE: Record<string, StoreCode> = {
  'athleticgreensusa.myshopify.com': us,
  'athleticgreenseu.myshopify.com': eu,
  'athleticgreensuk.myshopify.com': uk,
  '': 'jp',
  'athleticgreens-qa.myshopify.com': qa,
  'development-ag1.myshopify.com': dev,
  'ag-development-eu.myshopify.com': eud,
  'ag-development-uk.myshopify.com': ukd
} as const;

export const SHOPIFY_STOREFRONT_API_TOKEN: Record<StoreCode, string> = {
  [us]: '6d2b076b055db2b8f74f1aaa07f33c81',
  [au]: '6d2b076b055db2b8f74f1aaa07f33c81',
  [nz]: '6d2b076b055db2b8f74f1aaa07f33c81',
  [eu]: '815d3a04084d7fd471c70983be3608b4',
  [jp]: '',
  [uk]: '7eb1dc16693c7abbf9262426f8e4a86b',
  [dev]: 'e6bc6ca6f5b6dd01cce82c40dceceef3',
  [qa]: '6b5ddcd0ef4d1be4fb8589c3575878b0',
  [aud]: '6b5ddcd0ef4d1be4fb8589c3575878b0',
  [nzd]: '6b5ddcd0ef4d1be4fb8589c3575878b0',
  [eud]: '4e07489ea939d34f0c149863897568fb',
  [ukd]: '8a3d8b2978500bb3618afbfde702ea28'
} as const;

export type VariantIdObject = {
  default: string;
  freeShipping?: string;
  tropical?: string;
  berry?: string;
  citrus?: string;
  chocolate?: string;
  chocolateMint?: string;
  mixedBerry?: string;
};

export type AGZVariantIdObject = {
  chocolate?: string;
  chocolateMint?: string;
  mixedBerry?: string;
};

export type FlavorIdsObject = {
  original: readonly string[];
  tropical?: readonly string[];
};

export const SHOPIFY_AG1_POUCH_OTP_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41224153694306' },
  [au]: { default: '41909788803170' },
  [nz]: { default: '41909788803170' },
  [eu]: { default: '49969143939412' },
  [uk]: { default: '41282917892173' },
  [jp]: { default: '' },
  [dev]: { default: '48768340951355' },
  [qa]: { default: '41101567000619' },
  [aud]: { default: '41463139467307' },
  [nzd]: { default: '41463139467307' },
  [eud]: { default: '51637595898225' },
  [ukd]: { default: '49709800358188' }
} as const;

export const SHOPIFY_AG1_POUCH_OTP_VARIANT_ID_V53: Record<StoreCode, VariantIdObject> = {
  [us]: {
    default: '41592076861538',
    tropical: '41592076894306',
    citrus: '42081477722210',
    berry: '42081484865634'
  },
  [au]: { default: '41592076861538', tropical: '41592076894306' },
  [nz]: { default: '41592076861538', tropical: '41592076894306' },
  [eu]: { default: '49969143939412', tropical: '' },
  [uk]: { default: '41282917892173', tropical: '' },
  [jp]: { default: '', tropical: '' },
  [dev]: { default: '48768328663355', tropical: '' },
  [qa]: {
    default: '41206679339051',
    tropical: '41207480352811',
    citrus: '41897463939115',
    berry: '41897470787627'
  },
  [aud]: { default: '41206679339051', tropical: '41207480352811' },
  [nzd]: { default: '41206679339051', tropical: '41207480352811' },
  [eud]: { default: '51637595701617', tropical: '' },
  [ukd]: { default: '49709799473452', tropical: '' }
} as const;

export const SHOPIFY_AG1_POUCH_OTP_WELCOME_KIT: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41613281263714' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '52138028958036' },
  [uk]: { default: '53489816994173' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '41413479399467' },
  [aud]: { default: '' },
  [nzd]: { default: '' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_AG1_FAMILY_PLAN_WELCOME_KIT: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41518710325346' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '' },
  [uk]: { default: '' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '' },
  [aud]: { default: '' },
  [nzd]: { default: '' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41224153628770', freeShipping: '41469331112034' },
  [au]: { default: '41909790703714' },
  [nz]: { default: '41909790703714' },
  [eu]: { default: '49366284009812' },
  [uk]: { default: '41190860128333' },
  [jp]: { default: '' },
  [dev]: { default: '48768328663355' },
  [qa]: { default: '41101566836779', freeShipping: '41169600249899' },
  [aud]: { default: '41463143694379' },
  [nzd]: { default: '41463143694379' },
  [eud]: { default: '51637595701617' },
  [ukd]: { default: '49709799473452' }
} as const;

export const SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID_V53: Record<StoreCode, VariantIdObject> = {
  [us]: {
    default: '41592067031138',
    tropical: '41592067162210',
    citrus: '42081497808994',
    berry: '42081495842914'
  },
  [au]: { default: '41592067031138', tropical: '41592067162210' },
  [nz]: { default: '41592067031138', tropical: '41592067162210' },
  [eu]: { default: '49366284009812', tropical: '' },
  [uk]: { default: '41190860128333', tropical: '' },
  [jp]: { default: '', tropical: '' },
  [dev]: { default: '48768328663355', tropical: '' },
  [qa]: {
    default: '41206686973995',
    tropical: '41207480483883',
    citrus: '41897462759467',
    berry: '41897472196651'
  },
  [aud]: { default: '41206686973995', tropical: '41207480483883' },
  [nzd]: { default: '41206686973995', tropical: '41207480483883' },
  [eud]: { default: '51637595701617', tropical: '' },
  [ukd]: { default: '49709799473452', tropical: '' }
} as const;

export const SHOPIFY_AG1_POUCH_SINGLE_WELCOME_KIT: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41613281788002' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '52138050781524' },
  [uk]: { default: '53489817059709' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '41413479432235' },
  [aud]: { default: '' },
  [nzd]: { default: '' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_AG1_SCOOP_VARIANT_V53: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41624842633314', tropical: '' },
  [au]: { default: '41624842633314', tropical: '' },
  [nz]: { default: '41624842633314', tropical: '' },
  [eu]: { default: '41592090165346', tropical: '' },
  [uk]: { default: '41592090165346', tropical: '' },
  [jp]: { default: '', tropical: '' },
  [dev]: { default: '51707213545835', tropical: '' },
  [qa]: { default: '41208233033771', tropical: '' },
  [aud]: { default: '41208233033771', tropical: '' },
  [nzd]: { default: '41208233033771', tropical: '' },
  [eud]: { default: '41592090165346', tropical: '' },
  [ukd]: { default: '41592090165346', tropical: '' }
} as const;

export const SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41224153661538', freeShipping: '41469331177570' },
  [au]: { default: '41909790834786' },
  [nz]: { default: '41909790834786' },
  [eu]: { default: '49366284271956' },
  [uk]: { default: '41190860521549' },
  [jp]: { default: '' },
  [dev]: { default: '48768333742395' },
  [qa]: { default: '41101566869547', freeShipping: '41169600086059' },
  [aud]: { default: '41463141105707' },
  [nzd]: { default: '41463141105707' },
  [eud]: { default: '51637595734385' },
  [ukd]: { default: '49709799637292' }
} as const;

export const SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53: Record<StoreCode, VariantIdObject> = {
  [us]: {
    default: '41592067129442',
    tropical: '41592067194978',
    citrus: '42081568424034',
    berry: '42081571012706'
  },
  [au]: {
    default: '41592067129442',
    tropical: '41592067194978'
  },
  [nz]: {
    default: '41592067129442',
    tropical: '41592067194978'
  },
  [eu]: { default: '49366284271956', tropical: '' },
  [uk]: { default: '41190860521549', tropical: '' },
  [jp]: { default: '', tropical: '' },
  [dev]: { default: '48768328663355', tropical: '' },
  [qa]: {
    default: '41206690611243',
    tropical: '41207481172011',
    citrus: '41897063514155',
    berry: '41897474195499'
  },
  [aud]: { default: '41206690611243', tropical: '41207481172011' },
  [nzd]: { default: '41206690611243', tropical: '41207481172011' },
  [eud]: { default: '51637595701617', tropical: '' },
  [ukd]: { default: '49709799473452', tropical: '' }
} as const;

export const SHOPIFY_AG1_POUCH_DOUBLE_WELCOME_KIT: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41613297418338' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '52138059694420' },
  [uk]: { default: '53489817158013' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '41413479465003' },
  [aud]: { default: '' },
  [nzd]: { default: '' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_TRAVEL_PACK_OTP_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41224153727074' },
  [au]: { default: '41909790244962' },
  [nz]: { default: '41909790244962' },
  [eu]: { default: '49969144070484' },
  [uk]: { default: '41282917924941' },
  [jp]: { default: '' },
  [dev]: { default: '48768367853883' },
  [qa]: { default: '41101567033387' },
  [aud]: { default: '41463139500075' },
  [nzd]: { default: '41463139500075' },
  [eud]: { default: '51637595930993' },
  [ukd]: { default: '49709800423724' }
} as const;

export const SHOPIFY_TRAVEL_PACK_OTP_VARIANT_ID_V53: Record<StoreCode, VariantIdObject> = {
  [us]: {
    default: '41592318427234',
    tropical: '41592318460002',
    citrus: '42081572749410',
    berry: '42081575436386'
  },
  [au]: { default: '41592318427234', tropical: '41592318460002' },
  [nz]: { default: '41592318427234', tropical: '41592318460002' },
  [eu]: { default: '49969144070484', tropical: '' },
  [uk]: { default: '41282917924941', tropical: '' },
  [jp]: { default: '', tropical: '' },
  [dev]: { default: '48768328663355', tropical: '' },
  [qa]: {
    default: '41206680256555',
    tropical: '41207481925675',
    citrus: '41897478717483',
    berry: '41897483436075'
  },
  [aud]: { default: '41206680256555', tropical: '41207481925675' },
  [nzd]: { default: '41206680256555', tropical: '41207481925675' },
  [eud]: { default: '51637595701617', tropical: '' },
  [ukd]: { default: '49709799473452', tropical: '' }
} as const;

export const SHOPIFY_TRAVEL_PACK_OTP_WELCOME_KIT: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41613298499682' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '52138077552980' },
  [uk]: { default: '53489817190781' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '41413479497771' },
  [aud]: { default: '' },
  [nzd]: { default: '' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41224153759842', freeShipping: '41469331406946' },
  [au]: { default: '41909791424610' },
  [nz]: { default: '41909791424610' },
  [eu]: { default: '49366284566868' },
  [uk]: { default: '41190861078605' },
  [jp]: { default: '' },
  [dev]: { default: '48768372638011' },
  [qa]: { default: '41101567066155', freeShipping: '41169599758379' },
  [aud]: { default: '41463141171243' },
  [nzd]: { default: '41463141171243' },
  [eud]: { default: '51637595799921' },
  [ukd]: { default: '49709799833900' }
} as const;

export const SHOPIFY_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID_V53: Record<StoreCode, VariantIdObject> = {
  [us]: {
    default: '41592067063906',
    tropical: '41592070373474',
    citrus: '42081583104098',
    berry: '42081586479202'
  },
  [au]: { default: '41592067063906', tropical: '41592070373474' },
  [nz]: { default: '41592067063906', tropical: '41592070373474' },
  [eu]: { default: '49366284566868', tropical: '' },
  [uk]: { default: '41190861078605', tropical: '' },
  [jp]: { default: '', tropical: '' },
  [dev]: { default: '48768328663355', tropical: '' },
  [qa]: {
    default: '41206688055339',
    tropical: '41207481761835',
    citrus: '41897480519723',
    berry: '41897483927595'
  },
  [aud]: { default: '41206688055339', tropical: '41207481761835' },
  [nzd]: { default: '41206688055339', tropical: '41207481761835' },
  [eud]: { default: '51637595701617', tropical: '' },
  [ukd]: { default: '49709799473452', tropical: '' }
} as const;

export const SHOPIFY_TRAVEL_PACK_SINGLE_WELCOME_KIT: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41613299155042' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '52138081943892' },
  [uk]: { default: '53489817223549' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '41413479759915' },
  [aud]: { default: '' },
  [nzd]: { default: '' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_AGZ_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID: Record<StoreCode, AGZVariantIdObject> =
  {
    [us]: {
      chocolate: '42097170808930', // AGZ Sub Only ($79)
      chocolateMint: '42097160683618', // AGZ Sub Only ($79)
      mixedBerry: '42097109860450' // AGZ Sub Only ($79)
    },
    [au]: {},
    [nz]: {},
    [eu]: {},
    [uk]: {},
    [jp]: {},
    [dev]: {},
    [qa]: {
      chocolate: '41941031682091', // AGZ Sub Only ($79)
      chocolateMint: '41941039546411', // AGZ Sub Only ($79)
      mixedBerry: '41859047817259' // AGZ Sub Only ($79)
    },
    [aud]: {},
    [nzd]: {},
    [eud]: {},
    [ukd]: {}
  } as const;

export const SHOPIFY_AGZ_TRAVEL_PACK_DISCOUNTED_SUB_VARIANT_ID: Record<
  StoreCode,
  AGZVariantIdObject
> = {
  [us]: {
    chocolate: '41869807353954', // Active AG1 ($69) - current non-NSF SKU
    chocolateMint: '41869807321186', // Active AG1 ($69) - current non-NSF SKU
    mixedBerry: '42097109270626' // Active AG1 ($69)
  },
  [au]: {},
  [nz]: {},
  [eu]: {},
  [uk]: {},
  [jp]: {},
  [dev]: {},
  [qa]: {
    chocolate: '41940566179883', // Active AG1 ($69)
    chocolateMint: '41941038923819', // Active AG1 ($69)
    mixedBerry: '41940565590059' // Active AG1 ($69)
  },
  [aud]: {},
  [nzd]: {},
  [eud]: {},
  [ukd]: {}
} as const;

export const SHOPIFY_AGZ_TRAVEL_PACK_OTP_VARIANT_ID: Record<StoreCode, AGZVariantIdObject> = {
  [us]: {
    chocolate: '42097173397602', // OTP ($89)
    chocolateMint: '42097159405666', // OTP ($89)
    mixedBerry: '42097153933410' // OTP ($89)
  },
  [au]: {},
  [nz]: {},
  [eu]: {},
  [uk]: {},
  [jp]: {},
  [dev]: {},
  [qa]: {
    chocolate: '41941037023275', // OTP ($89)
    chocolateMint: '41941040726059', // OTP ($89)
    mixedBerry: '41859047882795' // OTP ($89)
  },
  [aud]: {},
  [nzd]: {},
  [eud]: {},
  [ukd]: {}
} as const;

export const SHOPIFY_AGZ_WELCOME_KIT_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41865625141346' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '' },
  [uk]: { default: '' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '41409553956907' },
  [aud]: { default: '' },
  [nzd]: { default: '' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_AG_OMEGA_SUB_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '39391371788386' },
  [au]: { default: '7342301741154' },
  [nz]: { default: '7342301741154' },
  [eu]: { default: '19288045584453' },
  [uk]: { default: '33144558288973' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '40653443989547' },
  [aud]: { default: '41463142252587' },
  [nzd]: { default: '41463142252587' },
  [eud]: { default: '45380520509719' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41224153792610', freeShipping: '41469331865698' },
  [au]: { default: '41909792637026' },
  [nz]: { default: '41909792637026' },
  [eu]: { default: '49366285058388' },
  [uk]: { default: '41190861307981' },
  [jp]: { default: '' },
  [dev]: { default: '48768376045883' },
  [qa]: { default: '41101567098923', freeShipping: '41169599496235' },
  [aud]: { default: '41463141302315' },
  [nzd]: { default: '41463141302315' },
  [eud]: { default: '51637595865457' },
  [ukd]: { default: '49709800259884' }
} as const;

export const SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53: Record<StoreCode, VariantIdObject> = {
  [us]: {
    default: '41592067096674',
    tropical: '41592070406242',
    citrus: '42081590804578',
    berry: '42081596342370'
  },
  [au]: { default: '41592067096674', tropical: '41592070406242' },
  [nz]: { default: '41592067096674', tropical: '41592070406242' },
  [eu]: { default: '49366285058388', tropical: '' },
  [uk]: { default: '41190861307981', tropical: '' },
  [jp]: { default: '', tropical: '' },
  [dev]: { default: '48768376045883', tropical: '' },
  [qa]: {
    default: '41206688153643',
    tropical: '41207481892907',
    citrus: '41897479962667',
    berry: '41897484288043'
  },
  [aud]: { default: '41206688153643', tropical: '41207481892907' },
  [nzd]: { default: '41206688153643', tropical: '41207481892907' },
  [eud]: { default: '51637595865457', tropical: '' },
  [ukd]: { default: '49709800259884', tropical: '' }
} as const;

export const SHOPIFY_TRAVEL_PACK_DOUBLE_WELCOME_KIT: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41613299482722' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '52138083320148' },
  [uk]: { default: '53489817256317' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '41413479858219' },
  [aud]: { default: '' },
  [nzd]: { default: '' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_5CT_TRAVEL_PACK_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '39391370772578' },
  [au]: { default: '41909797421154' },
  [nz]: { default: '41909797421154' },
  [eu]: { default: '29441113292869' },
  [uk]: { default: '33151349588045' },
  [jp]: { default: '' },
  [dev]: { default: '51707213480299' },
  [qa]: { default: '40653443006507' },
  [aud]: { default: '41463141957675' },
  [nzd]: { default: '41463141957675' },
  [eud]: { default: '45380520149271' },
  [ukd]: { default: '49709848625452' }
} as const;

export const SHOPIFY_5CT_TRAVEL_PACK_VARIANT_ID_V53: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41592090034274', tropical: '41592090067042' },
  [au]: { default: '41592090034274', tropical: '41592090067042' },
  [nz]: { default: '41592090034274', tropical: '41592090067042' },
  [eu]: { default: '29441113292869', tropical: '' },
  [uk]: { default: '33151349588045', tropical: '' },
  [jp]: { default: '', tropical: '' },
  [dev]: { default: '51707213480299', tropical: '' },
  [qa]: { default: '41206689398827', tropical: '41207482875947' },
  [aud]: { default: '41206689398827', tropical: '41207482875947' },
  [nzd]: { default: '41206689398827', tropical: '41207482875947' },
  [eud]: { default: '45380520149271', tropical: '' },
  [ukd]: { default: '49709848625452', tropical: '' }
} as const;

export const SHOPIFY_5CT_TRAVEL_PACK_STANDALONE_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41983939280994' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '' },
  [uk]: { default: '' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '' },
  [aud]: { default: '' },
  [nzd]: { default: '' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_SHAKER_STANDALONE_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '41624841224290' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '' },
  [uk]: { default: '' },
  [jp]: { default: '' },
  [dev]: { default: '48709440995643' },
  [qa]: { default: '40862648434731' },
  [aud]: { default: '' },
  [nzd]: { default: '' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const ANNUAL_PLAN_VARIANT_ID: Record<StoreCode, VariantIdObject> = {
  [us]: { default: '' },
  [au]: { default: '' },
  [nz]: { default: '' },
  [eu]: { default: '' },
  [uk]: { default: '' },
  [jp]: { default: '' },
  [dev]: { default: '' },
  [qa]: { default: '41903695921195' },
  [aud]: { default: '41903695921195' },
  [nzd]: { default: '41903695921195' },
  [eud]: { default: '' },
  [ukd]: { default: '' }
} as const;

export const SHOPIFY_OMEGA_SUB_BUNDLE_VARIANT_ID: Record<
  StoreCode,
  { default: string; subscriptionPrice: string; bundlePrice: string }
> = {
  [us]: {
    default: '41888651149410',
    subscriptionPrice: '41227853299810',
    bundlePrice: '41814907912290'
  },
  [au]: { default: '', subscriptionPrice: '', bundlePrice: '' },
  [nz]: { default: '', subscriptionPrice: '', bundlePrice: '' },
  [eu]: { default: '', subscriptionPrice: '', bundlePrice: '' },
  [uk]: { default: '', subscriptionPrice: '', bundlePrice: '' },
  [jp]: { default: '', subscriptionPrice: '', bundlePrice: '' },
  [dev]: { default: '', subscriptionPrice: '', bundlePrice: '' },
  [qa]: {
    default: '41445145673771',
    subscriptionPrice: '41367640408107',
    bundlePrice: '40653443989547'
  },
  [aud]: { default: '', subscriptionPrice: '', bundlePrice: '' },
  [nzd]: { default: '', subscriptionPrice: '', bundlePrice: '' },
  [eud]: { default: '', subscriptionPrice: '', bundlePrice: '' },
  [ukd]: { default: '', subscriptionPrice: '', bundlePrice: '' }
} as const;

export const BLOTOUT_STORE_MAP: Record<StoreCode, string> = {
  [us]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [au]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [nz]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [eu]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_EU || '',
  [uk]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_UK || '',
  [jp]: '',
  [qa]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [aud]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [nzd]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [dev]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [eud]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_EU || '',
  [ukd]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_UK || ''
} as const;

export const BLOTOUT_LOCALE_MAP: Record<LocaleEnum, string> = {
  [LocaleEnum.enUS]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [LocaleEnum.apacUS]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_APAC || '',
  [LocaleEnum.enAU]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [LocaleEnum.enNZ]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [LocaleEnum.enUK]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_UK || '',
  [LocaleEnum.enEU]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_EU || '',
  [LocaleEnum.deEU]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_EU || '',
  [LocaleEnum.seEU]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_EU || '',
  [LocaleEnum.nlEU]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_EU || '',
  [LocaleEnum.esEU]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_EU || '',
  [LocaleEnum.frEU]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_EU || '',
  [LocaleEnum.enJP]: '',
  [LocaleEnum.jaJP]: '',
  [LocaleEnum.enDev]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [LocaleEnum.enQa]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [LocaleEnum.deQa]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [LocaleEnum.enAud]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [LocaleEnum.enNzd]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL || '',
  [LocaleEnum.enEud]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_EU || '',
  [LocaleEnum.deEud]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_EU || '',
  [LocaleEnum.enUkd]: process.env.NEXT_PUBLIC_BLOTOUT_EDGE_URL_UK || ''
} as const;

export function getShopifyApiUrl(domain: string, version: string, isAdmin: boolean = false) {
  return `https://${domain}/${isAdmin ? 'admin/' : ''}api/${version}/graphql.json` as const;
}

// `https://${SHOPIFY_STORE_DOMAIN[store]}/admin/api/2023-01/customers/${id.replace('gid://shopify/Customer/', '')}/send_invite.json`,
export function getShopifyRestApiUrl(domain: string, version: string, isAdmin: boolean = false) {
  return `https://${domain}/${isAdmin ? 'admin/' : ''}api/${version}` as const;
}

export const SHOPIFY_STOREFRONT_API_URL = storeCodeSchema.options.reduce(
  (acc, cur) => ({
    ...acc,
    [cur]: getShopifyApiUrl(SHOPIFY_STORE_DOMAIN[cur], SHOPIFY_API_VERSION)
  }),
  {} as const as Record<StoreCode, string>
);

export const SHOPIFY_ADMIN_API_URL = storeCodeSchema.options.reduce(
  (acc, cur) => ({
    ...acc,
    [cur]: getShopifyApiUrl(SHOPIFY_STORE_DOMAIN[cur], SHOPIFY_API_VERSION, true)
  }),
  {} as const as Record<StoreCode, string>
);

export const SHOPIFY_REST_API_URL = storeCodeSchema.options.reduce(
  (acc, cur) => ({
    ...acc,
    [cur]: getShopifyRestApiUrl(SHOPIFY_STORE_DOMAIN[cur], SHOPIFY_API_VERSION)
  }),
  {} as const as Record<StoreCode, string>
);

export const SHOPIFY_ADMIN_REST_API_URL = storeCodeSchema.options.reduce(
  (acc, cur) => ({
    ...acc,
    [cur]: getShopifyRestApiUrl(SHOPIFY_STORE_DOMAIN[cur], SHOPIFY_API_VERSION, true)
  }),
  {} as const as Record<StoreCode, string>
);

export function getShopifyStorefrontApiHeaders(store: StoreCode) {
  return {
    'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_API_TOKEN[store]
  } as const;
}

const upscribeUrl = {
  production: 'https://endpoint.upscribe.io',
  stage: 'https://fxpflqhs52.execute-api.us-east-1.amazonaws.com/stage'
} as const;

export const UPSCRIBE_API_URL = storeCodeSchema.options.reduce(
  (acc, cur) => ({
    ...acc,
    [cur]:
      process.env.UPSCRIBE_API_URL ||
      (STORES_QA.includes(cur) ? upscribeUrl.stage : upscribeUrl.production)
  }),
  {} as const as Record<StoreCode, string>
);

export const LOQATE_KEY = 'TG72-EN97-BE48-ZZ48';

export const RECAPTCHA_SITE_KEY =
  process.env.RECAPTCHA_SITE_KEY || '6LeERv4fAAAAAJS0YK7Z1vCm7EAb8vHuU4ikCmYG';

export const KLAVIYO_TOKENS: Partial<Record<StoreCode, string>> = {
  us: 'xZPVA5',
  au: 'xZPVA5',
  eu: 'FrtzSL',
  uk: 'QQAAC6',
  jp: 'FrtzSL',
  qa: 'WaqzbJ'
} as const;

export const AFTERSHIP_API_URL = 'https://api.aftership.com/tracking/2025-01';
export const AFTERSHIP_API_KEYS: Readonly<Record<StoreCode, string>> = JSON.parse(
  process.env.AFTERSHIP_API_KEYS ?? '{}'
);

export const SUBSCRIPTION_API_URL: Record<StoreCode, string> = {
  [us]: 'https://subscription-api.athleticgreens.com',
  [au]: 'https://subscription-api.athleticgreens.com',
  [nz]: 'https://subscription-api.athleticgreens.com',
  [eu]: 'https://subscription-api.athleticgreens.com',
  [uk]: 'https://subscription-api.athleticgreens.com',
  [jp]: 'https://subscription-api.athleticgreens.com',
  [dev]: 'https://subscription-api-dev.athleticgreens.com',
  [qa]: 'https://subscription-api-qa.athleticgreens.com',
  [aud]: 'https://subscription-api-qa.athleticgreens.com',
  [nzd]: 'https://subscription-api-qa.athleticgreens.com',
  [eud]: 'https://subscription-api-qa.athleticgreens.com',
  [ukd]: 'https://subscription-api-qa.athleticgreens.com'
} as const;

const STORE_TO_SUBSCRIPTION_API_REGION_MAP = {
  us: 'us',
  au: 'us',
  nz: 'us',
  qa: 'us',
  dev: 'us',
  aud: 'us',
  nzd: 'us',
  uk: 'uk',
  jp: 'jp',
  eu: 'eu',
  eud: 'eu',
  ukd: 'uk'
} as const;

export function mapStoreToSubscriptionApiRegion(store: StoreCode) {
  return STORE_TO_SUBSCRIPTION_API_REGION_MAP[store];
}

export const SHOPIFY_STORE_BRAND: Record<StoreCode, string> = {
  [us]: 'Athletic Greens',
  [au]: 'Athletic Greens (AU)',
  [nz]: 'Athletic Greens (NZ)',
  [eu]: 'Athletic Greens (EU)',
  [uk]: 'Athletic Greens (UK)',
  [jp]: 'Athletic Greens (JP)',
  [qa]: 'Quality Assurance',
  [dev]: 'Development',
  [aud]: 'Quality Assurance (AU)',
  [nzd]: 'Quality Assurance (NZ)',
  [eud]: 'Quality Assurance (EU)',
  [ukd]: 'Quality Assurance (UK)'
} as const;

export const V53_VARIANT_ORIGINAL_PRICES: Record<string, number> = {
  // Single Pouch
  '41101566836779': 99, // QA Original Single
  '41169600249899': 99, // QA Tropical Single
  '41224153628770': 99, // US Original Single
  '41469331112034': 99, // US Tropical Single
  '49366284009812': 99, // EU Original Single
  '41190860128333': 99, // UK Original Single
  '48768328663355': 99, // Dev Original Single
  '51637595701617': 99, // EU Dev Original Single
  '49709799473452': 99, // UK Dev Original Single

  // Double Pouch
  '41101566869547': 198, // QA Original Double
  '41169600086059': 198, // QA Tropical Double
  '41224153661538': 198, // US Original Double
  '41469331177570': 198, // US Tropical Double
  '49366284271956': 198, // EU Original Double
  '41190860521549': 198, // UK Original Double
  '48768333742395': 198, // Dev Original Double
  '51637595734385': 198, // EU Dev Original Double
  '49709799637292': 198, // UK Dev Original Double

  // Travel Packs Single
  '41101567066155': 109, // QA Original Travel Single
  '41169599758379': 109, // QA Tropical Travel Single
  '41224153759842': 109, // US Original Travel Single
  '41469331406946': 109, // US Tropical Travel Single
  '49366284566868': 109, // EU Original Travel Single
  '41190861078605': 109, // UK Original Travel Single
  '48768372638011': 109, // Dev Original Travel Single
  '51637595799921': 109, // EU Dev Original Travel Single
  '49709799833900': 109, // UK Dev Original Travel Single

  // Travel Packs Double
  '41101567098923': 218, // QA Original Travel Double
  '41169599496235': 218, // QA Tropical Travel Double
  '41224153792610': 218, // US Original Travel Double
  '41469331865698': 218, // US Tropical Travel Double
  '49366285058388': 218, // EU Original Travel Double
  '41190861307981': 218, // UK Original Travel Double
  '48768376045883': 218, // Dev Original Travel Double
  '51637595865457': 218, // EU Dev Original Travel Double
  '49709800259884': 218 // UK Dev Original Travel Double
} as const;

export const SHOPIFY_AG1_FREE_SHAKER_VARIANT_ID: Record<StoreCode, string> = {
  [us]: '41544786542690',
  [au]: '41544786542690',
  [nz]: '41544786542690',
  [eu]: '',
  [uk]: '',
  [jp]: '',
  [dev]: '',
  [qa]: '41201983029291',
  [aud]: '41201983029291',
  [nzd]: '41201983029291',
  [eud]: '',
  [ukd]: ''
} as const;
